import React from 'react';
import PropTypes from 'prop-types';
import { LuClipboardList, LuLoaderCircle, LuPlus } from 'react-icons/lu';
import Button from '../../../components/ui/Button';
import useSmoText from '../smoText';

/** "12 / 40 kayıt (30 mevcut) (2 yeni)" pill of the manual data entry. */
export const EntryCount = ({ shown, total, filtered, existing, added }) => {
  const { label } = useSmoText();
  return (
    <span className="tw-inline-flex tw-h-9 tw-items-center tw-gap-1.5 tw-rounded-full tw-bg-sky-500/10 tw-px-3 tw-text-xs tw-font-semibold tw-text-sky-800 dark:tw-text-sky-200">
      <LuClipboardList aria-hidden="true" className="tw-h-4 tw-w-4" />
      {filtered ? label('entry.countFiltered', { shown, total }) : label('entry.count', { count: total })}
      {existing > 0 && <span className="tw-font-normal">{label('entry.existingCount', { count: existing })}</span>}
      {added > 0 && <span className="tw-font-normal">{label('entry.newCount', { count: added })}</span>}
    </span>
  );
};

EntryCount.propTypes = { shown: PropTypes.number.isRequired, total: PropTypes.number.isRequired, filtered: PropTypes.bool, existing: PropTypes.number, added: PropTypes.number };

/** Footer summary: rows plus existing / new badges. */
export const EntryFooterInfo = ({ shown, total, filtered, existing, added }) => {
  const { label } = useSmoText();
  return (
    <span className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-text-xs tw-text-slate-600 dark:tw-text-slate-300">
      <span>{filtered ? label('entry.rowsFiltered', { shown, total }) : label('entry.rows', { count: total })}</span>
      {existing > 0 && <span className="tw-rounded tw-bg-emerald-500/15 tw-px-1.5 tw-py-0.5 tw-font-semibold tw-text-emerald-800 dark:tw-text-emerald-200">{label('entry.existingBadge', { count: existing })}</span>}
      {added > 0 && <span className="tw-rounded tw-bg-amber-400/25 tw-px-1.5 tw-py-0.5 tw-font-semibold tw-text-amber-800 dark:tw-text-amber-200">{label('entry.newBadge', { count: added })}</span>}
    </span>
  );
};

EntryFooterInfo.propTypes = EntryCount.propTypes;

/** Loading / empty state of an entry table, with an optional "add row" action. */
export const EntryEmpty = ({ loading, icon: Icon = LuClipboardList, text, actionLabel, onAction }) => (
  <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-px-6 tw-py-14 tw-text-center">
    {loading
      ? <LuLoaderCircle aria-hidden="true" className="tw-h-8 tw-w-8 tw-animate-spin tw-text-teal-500" />
      : <span className="tw-grid tw-h-12 tw-w-12 tw-place-items-center tw-rounded-2xl tw-bg-slate-500/10 tw-text-slate-400"><Icon aria-hidden="true" className="tw-h-6 tw-w-6" /></span>}
    <p className="tw-max-w-md tw-text-sm tw-text-slate-500 dark:tw-text-slate-400">{text}</p>
    {actionLabel && (
      <Button size="sm" variant="success" onClick={onAction}>
        <LuPlus aria-hidden="true" className="tw-h-4 tw-w-4" />
        {actionLabel}
      </Button>
    )}
  </div>
);

EntryEmpty.propTypes = { loading: PropTypes.bool, icon: PropTypes.elementType, text: PropTypes.string.isRequired, actionLabel: PropTypes.string, onAction: PropTypes.func };
